import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const RestartContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'VT323', monospace;
  font-size: 48px;
  z-index: 10000;
`;

const TextContainer = styled.div`
  white-space: pre;
  text-align: center;
  line-height: 1.2;
  
  .ascii-art {
    font-size: 24px;
    letter-spacing: 2px;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

// Updated ASCII art for "davidOS"
const davidOSAscii = `
     _             _     _  ____   _____ 
     | |           (_)   | |/ __ \\ / ____|
   __| | __ ___   ___  __| | |  | | (___  
  / _\` |/ _\` \\ \\ / / |/ _\` | |  | |\\___ \\ 
 | (_| | (_| |\\ V /| | (_| | |__| |____) |
  \\__,_|\\__,_| \\_/ |_|\\__,_|\\____/|_____/ 
`;

export const RestartScreen = ({ onRestart }) => {
  const [text, setText] = useState('');
  const [showRestart, setShowRestart] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(0);
  const loadingFrames = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];
  const message = "u crashed me...";

  useEffect(() => {
    let currentIndex = 0;
    let typewriterInterval;
    let loadingInterval;

    // Start typewriter effect
    typewriterInterval = setInterval(() => {
      if (currentIndex < message.length) {
        setText(message.slice(0, currentIndex + 1));
        currentIndex++;
      }
    }, 100);

    // Switch to restart animation after 2.5s
    setTimeout(() => {
      clearInterval(typewriterInterval);
      setShowRestart(true);
      setText('');

      // Start loading animation
      loadingInterval = setInterval(() => {
        setLoadingIndex(prev => (prev + 1) % loadingFrames.length);
      }, 100);

      // Trigger restart after 2s of loading (reduced from 5s)
      setTimeout(() => {
        clearInterval(loadingInterval);
        onRestart();
      }, 2000);
    }, 2500);

    return () => {
      clearInterval(typewriterInterval);
      clearInterval(loadingInterval);
    };
  }, [onRestart]);

  return (
    <RestartContainer>
      <TextContainer>
        {!showRestart ? (
          text
        ) : (
          <>
            <div className="ascii-art">{davidOSAscii}</div>
            <div style={{ fontSize: '32px' }}>
              {`[ ${loadingFrames[loadingIndex]} ] RESTARTING...`}
            </div>
          </>
        )}
      </TextContainer>
    </RestartContainer>
  );
}; 